import React, { forwardRef, useMemo } from "react";
import { getFlagUrl } from "@helpers/getFlagUrl";
import CountryIcon from "@assets/icons/CountryIcon";
import SearchableSelect from "./SearchableSelect";
import { buildCountryOptions } from "../utils/countryOptions";

import "./CountrySelectProfile.sass";

const CountryOption = ({ option }) => (
  <>
    <img className="country-select-profile__flag" src={getFlagUrl(option.country)} alt="" />
    <span className="country-select-profile__label">{option.label}</span>
  </>
);

const CountrySelectProfile = forwardRef(
  (
    {
      countries = [],
      value,
      onChange,
      onOpenChange,
      locale,
      placeholder = "Select country",
      error = false,
      disabled = false,
      showArrow = true,
      triggerSelector,
    },
    ref,
  ) => {
    const options = useMemo(() => buildCountryOptions(countries, locale), [countries, locale]);
    const selectedKey = typeof value === "string" ? value.trim().toUpperCase() : "";
    const hasSelected = options.some((option) => option.value === selectedKey);

    const renderValue = (selectedOption) => (
      <>
        <span className="country-select-profile__content">
          {selectedOption ? (
            <CountryOption option={selectedOption} />
          ) : (
            <>
              <CountryIcon className="country-select-profile__placeholder-icon" />
              <span className="country-select-profile__placeholder">{placeholder}</span>
            </>
          )}
        </span>

        {showArrow && <span className="country-select-profile__arrow" aria-hidden="true" />}
      </>
    );

    return (
      <SearchableSelect
        ref={ref}
        options={options}
        value={selectedKey}
        onChange={onChange}
        onOpenChange={onOpenChange}
        disabled={disabled}
        triggerSelector={triggerSelector}
        className={`country-select-profile ${disabled ? "country-select-profile--disabled" : ""}`}
        controlClassName={`country-select-profile__control ${showArrow ? "has-arrow" : ""} ${
          hasSelected ? "" : "is-placeholder"
        } ${error ? "is-error" : ""}`}
        renderValue={renderValue}
        renderOption={(option) => <CountryOption option={option} />}
      />
    );
  },
);

CountrySelectProfile.displayName = "CountrySelectProfile";

export default CountrySelectProfile;
